import {Label} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

export const KilnOverviewLabel: React.FC = () => {
  const {t} = useTranslation()
  return (
    <Label
      title={''}
      data-cy="kiln_overview_card_label"
      {...{children: t('refraPlanning.kilnOverview.title')}}
      inverted
    />
  )
}
